var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"v-btn theme--light btn-big",attrs:{"id":"corpolate-checkout"},on:{"click":function($event){_vm.disableButton(); _vm.redirectToStripe()}}},[_vm._v("登録する")])}
var staticRenderFns = []

export { render, staticRenderFns }